export default "__VITE_PUBLIC_ASSET__cdc989ad__"